<div>
  <!-- Toolbar com botão Integrar discreto -->
  <div class="flex align-items-center justify-content-between mb-3">
    <span class="text-900 font-semibold text-lg">Dados Técnicos</span>
    <p-button label="Integrar" icon="pi pi-sync" [outlined]="true" severity="info" size="small" (onClick)="showIntegrarDialog()" *appHasPermission="'ACTION_PRODRET_DADOSTEC_INTEGRAR'"></p-button>
  </div>

  <!-- Resultado da integração -->
  <div *ngIf="resultadoIntegracao" class="border-1 surface-border border-round p-3 mb-3 surface-50">
    <div class="flex align-items-center justify-content-between mb-3">
      <div class="flex align-items-center gap-2">
        <i class="pi pi-check-circle text-green-500"></i>
        <span class="text-900 font-semibold">Dados obtidos do PIMS</span>
        <span class="text-500 text-sm ml-2">Empresa: {{ resultadoIntegracao.empresa }} | Filial: {{ resultadoIntegracao.filial }} | Instância: {{ resultadoIntegracao.instancia }} | Data: {{ resultadoIntegracao.dataMovimento }}</span>
      </div>
      <div class="flex gap-2">
        <p-button label="Descartar" icon="pi pi-times" severity="secondary" [outlined]="true" size="small" (onClick)="descartarResultado()"></p-button>
        <p-button label="Processar" icon="pi pi-send" severity="success" size="small" (onClick)="processar()" [loading]="loadingEnvio" *appHasPermission="'ACTION_PRODRET_DADOSTEC_INTEGRAR'"></p-button>
      </div>
    </div>
    <p-table [value]="getValoresPreenchidos(resultadoIntegracao)" [paginator]="false"
      styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [scrollable]="true" scrollHeight="15rem">
      <ng-template pTemplate="header">
        <tr>
          <th style="min-width: 180px;">Campo</th>
          <th style="min-width: 120px;">Valor</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td><code class="text-sm surface-ground border-round px-2 py-1">{{ formatLabel(item.key) }}</code></td>
          <td class="font-semibold">{{ item.value }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="2" class="text-center text-500 py-3">Nenhum valor preenchido.</td></tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Erro da integração -->
  <div *ngIf="erroIntegracao && !resultadoIntegracao" class="border-1 border-red-300 border-round p-3 mb-3 bg-red-50">
    <div class="flex align-items-center gap-2">
      <i class="pi pi-exclamation-triangle text-red-500"></i>
      <span class="text-red-700 font-medium">{{ erroIntegracao }}</span>
      <p-button icon="pi pi-times" [text]="true" severity="danger" size="small" (onClick)="erroIntegracao = ''" class="ml-auto"></p-button>
    </div>
  </div>

  <!-- Tabela de registros existentes -->
  <p-table [value]="registros" [paginator]="true" [rows]="20" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
    [rowsPerPageOptions]="[20, 50, 100]" [loading]="loading"
    styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
    [scrollable]="true" scrollHeight="40.5rem" [resizableColumns]="true"
    #dtDadosTec [globalFilterFields]="['empresa','filial','instancia','dataMovimento','fgStatusInteg','deMensagemInteg']">
    <ng-template pTemplate="caption">
      <div class="flex align-items-center justify-content-between flex-wrap gap-2">
        <span class="text-900 font-semibold">{{ totalRecords }} Registros</span>
        <div class="flex align-items-center gap-2">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dtDadosTec.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar..." />
          </span>
          <p-button icon="pi pi-refresh" [rounded]="true" [text]="true" severity="secondary" (onClick)="carregarDados()" pTooltip="Atualizar" tooltipPosition="top" [loading]="loading"></p-button>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th style="min-width: 50px; text-align: center;">Detalhes</th>
        <th style="min-width: 50px; text-align: center;">Enviar SAP</th>
        <th pSortableColumn="empresa" style="min-width: 100px;">Empresa <p-sortIcon field="empresa"></p-sortIcon></th>
        <th pSortableColumn="filial" style="min-width: 90px;">Filial <p-sortIcon field="filial"></p-sortIcon></th>
        <th pSortableColumn="instancia" style="min-width: 110px;">Instância <p-sortIcon field="instancia"></p-sortIcon></th>
        <th pSortableColumn="dataMovimento" style="min-width: 130px;">Dt. Movimento <p-sortIcon field="dataMovimento"></p-sortIcon></th>
        <th pSortableColumn="dtRecebido" style="min-width: 150px;">Dt. Recebido <p-sortIcon field="dtRecebido"></p-sortIcon></th>
        <th pSortableColumn="dtIntegSap" style="min-width: 150px;">Dt. Integ. ERP <p-sortIcon field="dtIntegSap"></p-sortIcon></th>
        <th pSortableColumn="deMensagemInteg" style="min-width: 200px;">Mensagem <p-sortIcon field="deMensagemInteg"></p-sortIcon></th>
        <th pSortableColumn="fgStatusInteg" style="min-width: 130px;">Status <p-sortIcon field="fgStatusInteg"></p-sortIcon></th>
        <th pSortableColumn="dataUltimaAtualizacao" style="min-width: 150px;">Últ. Atualização <p-sortIcon field="dataUltimaAtualizacao"></p-sortIcon></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
      <tr>
        <td style="text-align: center;">
          <p-button icon="pi pi-eye" [rounded]="true" [text]="true" severity="info" (onClick)="showDetalhes(item)" pTooltip="Ver detalhes" tooltipPosition="top"></p-button>
        </td>
        <td style="text-align: center;">
          <p-button icon="pi pi-cog" [rounded]="true" [text]="true" severity="warning" (onClick)="confirmEnviarSap(item)" [pTooltip]="item.fgStatusInteg === 'INTEGRADO' || item.fgStatusInteg === 'EM_PROCESSAMENTO' ? 'Registro já ' + item.fgStatusInteg : 'Enviar ao SAP'" tooltipPosition="top" [disabled]="item.fgStatusInteg === 'INTEGRADO' || item.fgStatusInteg === 'EM_PROCESSAMENTO'"></p-button>
        </td>
        <td><span class="font-semibold text-900">{{ item.empresa }}</span></td>
        <td>{{ item.filial }}</td>
        <td>{{ item.instancia }}</td>
        <td>{{ item.dataMovimento }}</td>
        <td>{{ item.dtRecebido | date:'dd/MM/yyyy HH:mm:ss' }}</td>
        <td>{{ item.dtIntegSap | date:'dd/MM/yyyy HH:mm:ss' }}</td>
        <td>
          <span *ngIf="item.deMensagemInteg" class="text-700 text-sm" [pTooltip]="item.deMensagemInteg" tooltipPosition="top">
            {{ item.deMensagemInteg.length > 40 ? (item.deMensagemInteg | slice:0:40) + '...' : item.deMensagemInteg }}
          </span>
        </td>
        <td><app-tag-status [status]="item.fgStatusInteg"></app-tag-status></td>
        <td>{{ item.dataUltimaAtualizacao | date:'dd/MM/yyyy HH:mm:ss' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="11">
          <div class="flex flex-column align-items-center justify-content-center py-5">
            <i class="pi pi-inbox text-4xl text-300 mb-3"></i>
            <span class="text-500 font-medium">Nenhum registro encontrado.</span>
            <span class="text-400 text-sm mt-1">Selecione uma instância e período no filtro acima.</span>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Dialog de Integração -->
  <p-dialog
    [(visible)]="displayIntegrarDialog"
    [modal]="true"
    [style]="{width: '480px'}"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    header="Integrar Dados Técnicos (PIMS)">
    <div class="grid p-fluid">
      <div class="col-12 field">
        <label class="font-medium text-800">Instância <span class="text-red-500">*</span></label>
        <app-empresa-dropdown [(selecionadas)]="selectedInstancia" modo="unico" />
      </div>
      <div class="col-12 field">
        <label class="font-medium text-800">Data Referência <span class="text-red-500">*</span></label>
        <p-calendar [(ngModel)]="integrationDate" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="Selecione a data" appendTo="body" [maxDate]="maxDate"></p-calendar>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <p-button label="Cancelar" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="displayIntegrarDialog = false"></p-button>
        <p-button label="Buscar do PIMS" icon="pi pi-download" severity="success" (onClick)="integrar()" [disabled]="!integrationDate || !selectedInstancia" [loading]="loadingIntegracao"></p-button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Dialog de Detalhes -->
  <p-dialog
    [(visible)]="displayDetalhes"
    [modal]="true"
    [style]="{width: '650px'}"
    [draggable]="false"
    [resizable]="false"
    header="Detalhes do Registro">
    <div *ngIf="itemSelecionado">
      <div class="grid mb-3">
        <div class="col-3"><span class="text-500">Empresa:</span> <strong>{{ itemSelecionado.empresa }}</strong></div>
        <div class="col-3"><span class="text-500">Filial:</span> <strong>{{ itemSelecionado.filial }}</strong></div>
        <div class="col-3"><span class="text-500">Instância:</span> <strong>{{ itemSelecionado.instancia }}</strong></div>
        <div class="col-3"><span class="text-500">Data:</span> <strong>{{ itemSelecionado.dataMovimento }}</strong></div>
      </div>
      <p-table [value]="getValoresPreenchidos(itemSelecionado)" [paginator]="false"
        styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [scrollable]="true" scrollHeight="20rem">
        <ng-template pTemplate="header">
          <tr>
            <th style="min-width: 180px;">Campo</th>
            <th style="min-width: 120px;">Valor</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-v>
          <tr>
            <td><code class="text-sm surface-ground border-round px-2 py-1">{{ formatLabel(v.key) }}</code></td>
            <td class="font-semibold">{{ v.value }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr><td colspan="2" class="text-center text-500 py-3">Nenhum valor preenchido.</td></tr>
        </ng-template>
      </p-table>
    </div>
    <ng-template pTemplate="footer">
      <p-button label="Enviar ao SAP" icon="pi pi-cog" severity="warning" [outlined]="true" (onClick)="confirmEnviarSap(itemSelecionado)" class="mr-2" [disabled]="itemSelecionado?.fgStatusInteg === 'INTEGRADO' || itemSelecionado?.fgStatusInteg === 'EM_PROCESSAMENTO'"></p-button>
      <p-button label="Fechar" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="displayDetalhes = false"></p-button>
    </ng-template>
  </p-dialog>

  <p-confirmDialog></p-confirmDialog>
</div>
